import { render, staticRenderFns } from "./AmbassadorSetup.vue?vue&type=template&id=6ad84961&scoped=true&"
import script from "./AmbassadorSetup.vue?vue&type=script&lang=js&"
export * from "./AmbassadorSetup.vue?vue&type=script&lang=js&"
import style0 from "./AmbassadorSetup.vue?vue&type=style&index=0&id=6ad84961&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad84961",
  null
  
)

export default component.exports